<div class="header">{{ 'pricingDetailsModal.sold' | translate }}</div>
<ng-container
  *ngFor="let price of soldPrices"
  [ngTemplateOutlet]="priceTemplate"
  [ngTemplateOutletContext]="{ priceModel: price, pricesFormGroup: soldPricesForm }"
></ng-container>
